import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @param cancelToken - Token to cancel multiple requests
 * @returns - Array of Terminal List of type string[]
 */

export const getMasterProNumberAPI = async (params: {
  search: string,
  page: number,
  limit: number,
  osdType: string,
  proType :string
}): Promise<string[]> => {
    try {
      const response = await axios.get<string[]>(getUrl(ApiType.MASTER_PRO_NUMBER), { params });
      return response.data;
    } catch (error) {
      return throwApiError(error, ErrorMessages.masterProNumber, { badRequestOrder: "errorsFirst" });
    }
};
